module.exports = __webpack_public_path__ + "img/LB.47f085f3.svg";